import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/wallet' },
  // { path: '/',name: 'home',    component: HomeView },
  { path: '/wallet',name: 'wallet',  component: () => import('../views/WalletPay.vue') },
  { path: '/return',  name: 'return',  component: () => import('../views/Return.vue') }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
